export default __webpack_public_path__ + "static/media/send-message-in-private.293d36b5.svg";